import React, { useState } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";

const UserFilter = ({
                            applyFilter,
                            localstorageKey=''
                        }) => {
    const filterInputs = {
        user_id: "",
        L1: "",
        L2:''
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
                filterFieldsData && localStorage.setItem("help_desk_users", JSON.stringify(filterFieldsData));
            }}
        >
            <ConstantInput
                label={"User Name or Email"}
                value={filterFieldsData && filterFieldsData.user_id}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, user_id: val });
                }}
            />

            <ConstantInput
                label={"L1 Name or Email"}
                value={filterFieldsData && filterFieldsData.L1}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, L1: val });
                }}
            />

            <ConstantInput
                label={"L2 Name or Email"}
                value={filterFieldsData && filterFieldsData.L2}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, L2: val });
                }}
            />
            <br />
            <br />
            <br />

            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src={Images?.ArrowRight} alt="" />
                </button>
                <br/>
                <br/>
                <button
                    onClick={() => {
                        localStorage.setItem(localstorageKey, JSON.stringify(filterInputs));
                        applyFilter(filterInputs);
                        localStorage.setItem(localstorageKey, JSON.stringify({}));
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default UserFilter;
